export enum StatusId {
  checkIn = 1,
  checkOut,
  form,
  done,
  cancelled,
}
